import React from "react";

export default function AuthLayout({

  title,
  subtitle,

  children

}) {

  return (

    <div className="auth-page">

      <div className="auth-card">

        <div className="auth-header">

          <div className="auth-logo">

            Priyara CRM

          </div>

          <h1>
            {title}
          </h1>

          <p>
            {subtitle}
          </p>

        </div>

        {children}

      </div>
<style>{`.auth-page {

  min-height: 100vh;

  display: flex;

  justify-content: center;

  align-items: center;

  padding: 20px;

  background: #f8fafc;
}

.auth-card {

  width: 100%;
  max-width: 450px;

  background: white;

  border-radius: 20px;

  padding: 40px;

  box-shadow:
    0 10px 40px
    rgba(0,0,0,0.08);
}

.auth-header {

  text-align: center;

  margin-bottom: 30px;
}

.auth-logo {

  font-size: 28px;

  font-weight: 700;

  margin-bottom: 10px;
}

.auth-header h1 {

  margin-bottom: 10px;
}

.auth-header p {

  color: #666;

  line-height: 1.5;
}
.auth-tabs {

  display: flex;

  background: #f3f4f6;

  border-radius: 12px;

  padding: 4px;

  margin-bottom: 20px;
}

.auth-tabs button {

  flex: 1;

  border: none;

  background: transparent;

  padding: 12px;

  border-radius: 10px;

  cursor: pointer;
}

.auth-tabs button.active {

  background: white;

  box-shadow:
    0 2px 8px
    rgba(0,0,0,.08);
}

.auth-tabs {

  display: flex;

  background: #f3f4f6;

  border-radius: 12px;

  padding: 4px;

  margin-bottom: 20px;
}

.auth-tabs button {

  flex: 1;

  border: none;

  background: transparent;

  padding: 12px;

  border-radius: 10px;

  cursor: pointer;
}

.auth-tabs button.active {

  background: white;

  box-shadow:
    0 2px 8px
    rgba(0,0,0,.08);
}

.auth-card input {

  width:93%;

  padding: 14px 16px;

  margin-bottom: 12px;

  border: 1px solid #ddd;

  border-radius: 12px;

  font-size: 15px;
}

.auth-card input:focus {

  outline: none;

  border-color: #2563eb;
}
  .auth-btn {

  width: 100%;

  padding: 14px;

  border: none;

  border-radius: 12px;

  cursor: pointer;

  font-size: 15px;

  font-weight: 600;
}
.auth-row {

  display: flex;

  gap: 12px;
}

.auth-row > div {

  flex: 1;
}

.auth-footer {

  margin-top: 24px;

  text-align: center;

  color: #666;
}

.otp-row {

  display: flex;

  justify-content: center;

  gap: 12px;

  margin: 30px 0;
}

.otp-input {

  width: 52px;

  height: 60px;

  text-align: center;

  font-size: 24px;

  font-weight: 600;

  border: 1px solid #ddd;

  border-radius: 12px;
}

.otp-input:focus {

  outline: none;

  border-color: #2563eb;
}
`}</style>
    </div>

  );
}